module.exports = __webpack_public_path__ + "img/PowerOfCash_DG.fcbb4031.jpg";